<template>
  <!-- begin:: Header Topbar -->
  <div class="kt-header__topbar">
    
    <!--begin: Language bar -->

    <img
      :src="cliente.caminhoVisualizacao"
      style="max-height: 30px; margin-top: 15px; margin-right: 15px"
    />

    <div class="kt-header__topbar-item kt-header__topbar-item--langs">
      <div
        v-if="notificationsCount > 0"
        class="kt-header__topbar-wrapper"
        id="kt_language_toggle"
        data-toggle="dropdown"
      >
        <span class="kt-header__topbar-icon">
          <notification-bell :count="notificationsCount" iconColor="#636177" fontSize="10px" animated/>
        </span>
      </div>
      <div
        class="dropdown-menu dropdown-menu-fit dropdown-menu-right"
        v-on:click.stop
      >
        <KTDropdownNotifications
         v-on:notifications-count="onNotificationsCount">
         </KTDropdownNotifications>

        
      </div>
    </div>


    <div class="kt-header__topbar-item kt-header__topbar-item--langs">
      <div
        class="kt-header__topbar-wrapper"
        id="kt_language_toggle"
        data-toggle="dropdown"
      >
        <span class="kt-header__topbar-icon">
          <img :src="languageFlag || getLanguageFlag" alt="" />
        </span>
      </div>
      <div
        class="dropdown-menu dropdown-menu-fit dropdown-menu-right"
        v-on:click.stop
      >
        <KTDropdownLanguage
          v-on:language-changed="onLanguageChanged"
        ></KTDropdownLanguage>
      </div>
    </div>
    <!--end: Language bar -->

    <!--begin: User Bar -->
    <div class="kt-header__topbar-item kt-header__topbar-item--user">
      <div
        class="kt-header__topbar-wrapper"
        id="kt_user_toggle"
        data-toggle="dropdown"
      >
        <div class="kt-header__topbar-user">
          <span class="kt-header__topbar-welcome kt-hidden-mobile">Olá,</span>
          <span class="kt-header__topbar-username kt-hidden-mobile">{{
            usuario.usuario.nome.split(" ")[0]
          }}</span>

          <!--use below badge element instead the user avatar to display username's first letter(remove kt-hidden class to display it) -->
          <span
            class="kt-badge kt-badge--username kt-badge--unified-success kt-badge--lg kt-badge--rounded kt-badge--bold"
            >{{ usuario.usuario.nome.substr(0, 1) }}</span
          >
        </div>
      </div>
      <div
        class="dropdown-menu dropdown-menu-fit dropdown-menu-xl dropdown-menu-right"
        v-on:click.stop
      >
        <KTDropdownUser></KTDropdownUser>
      </div>
    </div>
    <!--end: User Bar -->
  </div>
  <!-- end:: Header Topbar -->
</template>

<script>
import KTDropdownLanguage from "@/views/theme/topbar/DropdownLanguage.vue";
import KTDropdownUser from "@/views/theme/topbar/DropdownUser.vue";
import i18nService from "@/common/services/i18n.service.js";
import NotificationBell from 'vue-notification-bell';
import KTDropdownNotifications from "@/views/theme/topbar/DropdownNotifications.vue";
// import ApiService from "@/common/services/http/api.service";
// import SweetAlert from "@/common/services/sweetalert.service";

export default {
  name: "KTTopbar",
  data() {
    return {
      languageFlag: "",
      languages: i18nService.languages,
      usuario: {
        usuario: {
          nome: "",
        },
      },
      cliente: {},
      notificationsCount : 0,
    };
  },
  components: {
    KTDropdownLanguage,
    KTDropdownUser,
    NotificationBell,
    KTDropdownNotifications 
  },
  methods: {
    onLanguageChanged() {
      this.languageFlag = this.languages.find((val) => {
        return val.lang === i18nService.getActiveLanguage();
      }).flag;
    },
    onNotificationsCount() {
      this.notificationsCount = 1;
    },

  },
  computed: {
    getLanguageFlag() {
      return this.onLanguageChanged();
    },
  },
  mounted() {
    this.usuario = JSON.parse(window.localStorage.getItem("usuario"));
    if (this.usuario == null) {
      this.usuario = {
        usuario: {
          nome: "",
        },
      };
    }

    this.cliente = JSON.parse(window.localStorage.getItem("cliente"));
    if (this.cliente == null) {
      this.cliente = {
        caminhoVisualizacao: "",
      };
    }
  },
};
</script>
